import Text from '@/components/atoms/Text';
import * as S from './styles';
import { Fragment } from 'react';
import ServicoAssinaturaPaginaMobileFallback from './fallback';

// import ScrollAreaContainer from '@/components/molecules/ScrollAreaContainer';
// import { theme } from '@/styles/theme';
import { useServicoAssinaturaPageHookTypeReturn } from '../../hook/useServicoAssinaturaPageHook';
import Avatar from '@/components/atoms/Avatar';
// import Image from 'next/image';
import CarouselPlanosAssinatura from '@/components/organisms/CarouselPlanosAssinatura';
import { Separator } from '@/components/atoms/Separator';

import PaginaVendaMobileTemplate from '@/components/templates/PaginaVendaMobileTemplate';
import { Skeleton } from '@/components/atoms/Skeleton';
import Image from 'next/image';
import { theme } from '@/styles/theme';
import ScrollAreaContainer from '@/components/molecules/ScrollAreaContainer';
// import DropdownMenuTipoAssinatura from '@/components/molecules/DropdownMenuTipoAssinatura';

export default function ServicoAssinaturaPaginaMobile(
  props: useServicoAssinaturaPageHookTypeReturn,
) {
  const {
    assinatura,
    planoSelecionado,
    setPlanoSelecionado,
    adicionarProdutoASacola,
    // combosComOProduto,
    valorTotal,
    assinarAgora,
    planosAssinatura,
    // tipoAssinatura,
    // setTipoAssintura,
    assinaturaEmVigor,
    carregandoTitulosDisponiveisAssinatura,
    titulosDisponiveisAssinatura,
    bannerDestaqueAssinatura,
    discosDisponiveis,
  } = props;

  if (!assinatura) return <ServicoAssinaturaPaginaMobileFallback />;

  return (
    <PaginaVendaMobileTemplate
      $bannerDestaqueImagem={bannerDestaqueAssinatura}
      $breadcrumbPageTitle={assinatura?.nome ?? 'Assinatura'}
      $conteudoDescritivo={
        <Fragment>
          <S.Container>
            <S.ContainerEscolhaPlanos>
              <S.ContainerPlanosAssinaturaTexto>
                <Avatar
                  $size={3}
                  $shape="square"
                  $variant="solid"
                  $image={assinatura?.imagemThumb || assinatura?.imagem}
                  $color="neutral"
                  $preencherFundo={false}
                />
                <Text
                  $size={2}
                  $color="neutral"
                  $weight="medium"
                  $align="left"
                  $highContrast={true}
                  $text="Escolha o plano:"
                />
              </S.ContainerPlanosAssinaturaTexto>
            </S.ContainerEscolhaPlanos>
            <CarouselPlanosAssinatura
              $cliquePlano={(index) => setPlanoSelecionado(index)}
              $planoSelecionado={planoSelecionado}
              $planosAssinaturas={planosAssinatura}
            />
            <Separator $block={false} $orientation="horizontal" />
            <Text
              $size={2}
              $color="neutral"
              $weight="medium"
              $align="left"
              $highContrast={false}
              $text={assinatura.descricao}
            />
          </S.Container>
          <ScrollAreaContainer orientacao="horizontal">
            <S.ContainerPreviewCatalagoStreaming>
              {carregandoTitulosDisponiveisAssinatura
                ? Array.from({ length: 5 }).map((item, index) => (
                    <Skeleton
                      key={`${item}_${index}`}
                      style={{ width: 103, height: 153 }}
                    />
                  ))
                : discosDisponiveis != null
                  ? discosDisponiveis?.map((disco, index) => {
                      return (
                        <Image
                          key={'disco ' + index}
                          src={disco}
                          width={110}
                          height={110}
                          style={{
                            objectFit: 'cover',
                            // borderRadius: theme.radius[3],
                          }}
                          alt={`capa_disco_${assinatura.nome}_${index}`}
                          unoptimized
                        />
                      );
                    })
                  : titulosDisponiveisAssinatura?.map((titulo, index) => {
                      const { urlx1, urlx2, urlx3 } =
                        titulo.titulo.posterArquivo;
                      const posterArquivo = urlx3 || urlx2 || urlx1;
                      return (
                        <Image
                          key={titulo.tituloID}
                          src={posterArquivo}
                          width={103}
                          height={153}
                          style={{
                            objectFit: 'cover',
                            borderRadius: theme.radius[3],
                          }}
                          alt={`poster_${assinatura.nome}_${index}`}
                          unoptimized
                        />
                      );
                    })}
            </S.ContainerPreviewCatalagoStreaming>
          </ScrollAreaContainer>
        </Fragment>
      }
      $produtoJaFoiAssinado={assinaturaEmVigor}
      $valorTotal={valorTotal}
      $funcaoAdicionarAoCarrinho={adicionarProdutoASacola}
      $funcaoAcaoPrincial={assinarAgora}
      $textoBotaoAcaoPrincipal={
        assinaturaEmVigor ? 'Assinatura feita' : 'Assinar agora'
      }
    />
  );
}
